import { USER_ROLE_PERMISSIONS_FOR_STATES } from 'Src/ng2/shared/constants/user-role-permissions-for-states.constant';

angular.module('nv.routes.privacy-and-terms').config(configBlock);

function configBlock($stateProvider) {
  $stateProvider.state('privacy-and-terms', {
    url: '/privacy-and-terms',
    template: '<privacy-and-terms></privacy-and-terms>',
    data: {
      roles: USER_ROLE_PERMISSIONS_FOR_STATES['privacy-and-terms'],
    },
    onExit(SpinnerModal) {
      SpinnerModal.deactivateSpinner();
    },
  });
}
